import { rem, rgba } from 'polished';
import { transition, transitions } from './libs/transition';
import { media } from './libs/media';
import { css } from 'styled-components';

const blogColors = {
  primary: '#414141',
  secondary: '#FFD607',

  darkGray: '#606060',
  gray: '#AAAAAA',
  lightGray: '#000000',
  tagBg: '#F2F2F2',
  white: '#FFFFFF',
  black: '#000000',
  border: '#DDDDDD',
  link: '#337BCC',
};

const blogFonts = {
  primaryFont: `'Roboto', sans-serif;`,
  secondaryFont: `'Bebas Neue', cursive;`,
};

const blogShadows = {
  default: `0 ${rem(1)} ${rem(2)} ${rgba(blogColors.black, 0.16)}`,
};

const colors = {
  black: '#000000',
  white: '#FFFFFF',
  gray: 'rgba(17, 17, 17, 0.04)',
  lightGray: '#EEE',
  textPrimary: '#444444',
  highlight: '#fdf7d9',
  primary: '#111111',
  secondary: '#FFF46B',
  backgroundProducts: '#F7F6FA',
  footer: '#555555',
  secondaryTransparent: 'rgba(255,201,87, 0.1)',
  placeholder: '#999999',
  base: '#F2EEE8',
  footerLink: '#BBBBBB',
  loaderPrimary: '#3E3E3E',
  loaderSecondary: '#d4cdc3',
  inactiveFontColor: '#aaaaaa',
  fontHighlightColor: '#EE227B',
  primaryFontColor: '#3E3E3E',
  secondaryFontColor: '#3E3E3E',
  menuCartTextColor: '#555555',
  borderColor: '#CCCCCC',
  dotsColor: '#e3e3e3',
  activeDotColor: '#FFC957',
  sliderRailColor: '#eaeaea',
  successColor: '#9CC381',
  dangerColor: '#FF4464',
  red: '#FF0000',
  fuscousGray: '#514E49',
  separatorColor: '#eee',
  alto: '#dddddd',
  hover: 'rgb(49, 39, 131, 0.03)',
  disabled: '#F9F9F9',
  stockCountAvailable: '#2DCC8D',
  stockCountUnavailable: '#FF2D58',
  navSecondary: 'rgba(49, 39, 131, 0.04)',
  paginationSecondary: 'rgba(49, 39, 131, 0.06)',
};

const tagColors = {
  new: '#677DE6',
  action: '#FF2D58',
  saleout: '#CC0033',
};

const heatCategory = {
  primary: '#FF711C',
  navSecondary: 'rgb(255,113,28, 0.04)',
  paginationSecondary: 'rgb(255,113,28, 0.06)',
};

const woodCategory = {
  primary: '#A28777',
  navSecondary: 'rgb(162,135,119, 0.04)',
  paginationSecondary: 'rgb(162,135,119, 0.06)',
};

const restCategory = {
  primary: '#6A7B8D',
  navSecondary: 'rgb(106,123,141, 0.04)',
  paginationSecondary: 'rgb(106,123,141, 0.06)',
};

const categoryColors = {
  default: {
    primary: '#312783',
    secondary: 'rgb(49, 39, 131, 0.04)',
  },
  heat: {
    primary: '#FF711C',
    secondary: '#FFEEE3',
    tertiary: 'rgb(255,113,28, 0.04)',
  },
  wood: {
    primary: '#A28777',
    secondary: '#F4F0EE',
    tertiary: 'rgb(162,135,119, 0.04)',
  },
  rest: {
    primary: '#6A7B8D',
    secondary: '#EDEFF1',
    tertiary: 'rgb(106,123,141, 0.04)',
  },
};

const colorsNew = {
  white: '#FFFFFF',
  alabaster: '#F9F9F9',
  gallery: '#EFEFEF', // '#EEEEEE'
  alto: '#DDDDDD',
  silver: '#CCCCCC',
  silverChalice: '#AAAAAA',
  dustyGray: '#999999',
  boulder: '#777777',
  doveGray: '#737373',
  scorpion: '#5E5E5E',
  tundora: '#484848',
  mineShaft: '#282828',
  black: '#000000',
  red: '#FF0000',
  alizarinCrimson: '#E82933',
  bananaMania: '#FCF0BE',
  salomie: '#FFE88D',
  saffron: '#F6D33F',
  supernova: '#F4C500',
  yellow: '#FFFF00',
  jungleGreen: '#26B25E',
  mountainMeadow: '#18B35A',
  java: '#1DC5BA',
  cyan: '#00FFFF',
  mariner: '#337BCC',
  magenta: '#FF00FF',
  galleryOpacity: rgba(0, 0, 0, 0.8),
  altoOpacity: rgba(0, 0, 0, 0.16),
  grayOpacity: rgba(0, 0, 0, 0.5),
  panacheOpacity: rgba(38, 178, 94, 10),
  marinerOpacity: rgba(51, 123, 204, 0.1),
  jungleGreenOpacity: rgba(38, 178, 94, 0.1),
  whiteOpacity5: rgba(255, 255, 255, 0.05),
  whiteOpacity10: rgba(255, 255, 255, 0.1),
  whiteOpacity35: rgba(255, 255, 255, 0.35),
};

const font = {
  primary: `'Roboto', sans-serif;`,
  secondary: `'Bebas Neue', cursive;`,
  secondaryLight: `Montserrat Light;`,
  tertiary: `Open Sans;`,
  tertiarySemibold: `Open Sans Semibold;`,
};

//Golfccentrum colors
const color = {
  white: '#ffffff',
  white56: 'rgba(255, 255, 255, .56)',
  grayLight: rgba(232, 232, 232, 1),
  gray04: 'rgba(17, 17, 17, .04)',
  gray08: 'rgba(17, 17, 17, .08)',
  gray24: 'rgba(17, 17, 17, .24)',
  gray48: 'rgba(17, 17, 17, .48)',
  green: 'rgba(80, 158, 47, 1)',

  black24: 'rgba(0, 0, 0, .24)',

  primary: 'rgba(17, 17, 17, 1)',
  textPrimary: 'rgba(17, 17, 17, 1)',
  background: '#ffffff',
  backgroundDark: 'rgba(17, 17, 17, .04)',
  backgroundDarker: 'rgba(244, 244, 244, 1)',
  stockCountAvailable: 'rgba(80, 158, 47, 1)',
  stockCountUnavailable: '#FF2D58',

  borderColor: 'rgba(232, 232, 232, 1)',

  darkerLink: ' #005bc1',
  whiteOpacity10: colorsNew.whiteOpacity10,
  gray97: colorsNew.alabaster,
  gray86: colorsNew.alto,
  gray80: colorsNew.silver,
  gray66: colorsNew.silverChalice,
  gray36: colorsNew.scorpion,
  black: colorsNew.black,
  text: colorsNew.mineShaft,
  textSecondary: colorsNew.dustyGray,
  link: colorsNew.mariner,
  linkOpacity: colorsNew.marinerOpacity,
  brand: colorsNew.alizarinCrimson,
  success: colorsNew.jungleGreen,
  error: colorsNew.alizarinCrimson,
  warning: colorsNew.supernova,
  tag: colorsNew.java,
  alert: {
    warning: {
      background: colorsNew.bananaMania,
      border: colorsNew.saffron,
    },
  },
  gift: {
    background: colorsNew.jungleGreenOpacity,
    icon: colorsNew.jungleGreen,
  },
  printer: {
    background: colorsNew.marinerOpacity,
    color: colorsNew.mariner,
    backgroundSuccess: colorsNew.jungleGreenOpacity,
    colorSuccess: colorsNew.jungleGreen,
  },
  toner: {
    c: colorsNew.cyan,
    m: colorsNew.magenta,
    y: colorsNew.yellow,
  },
  login: {
    facebook: '#3B5998',
    google: '#DD4B39',
  },
  danger: colors.red,
};

const cartStep = {
  done: color.green,
  current: color.textPrimary,
  next: color.gray24,
  text: color.textPrimary,
  font: font.secondary,
  fontSize: `${rem(24)}`,
  mobileFontSize: `${rem(13)}`,
  mobileFont: font.primary,
};

const cartChooser = {
  active: color.green,
  bgHover: 'rgb(49, 39, 131, 0.08)',
};

const infoTexts = {
  colorError: '#FF2D58',
  colorInfo: color.textPrimary,
  colorSuccess: '#2DCC8D',
  bgError: '#FF2D5814',
  bgInfo: 'rgba(31, 109, 210, .04)',
  bgSucces: '#2dcc8d26',
  borderInfo: '#FFD21E52',
  iconColorInfo: '#1F6DD2',
};

const borders = {
  primary: `${rem(1)} solid ${color.borderColor}`,
  primaryWider: `${rem(2)} solid ${color.borderColor}`,
  primaryWiderGreen: `${rem(2)} solid ${color.green}`,
  secondary: `${rem(1)} solid #cccccc`,
  footer: `${rem(1)} solid rgba(255, 255, 255, 0.08)`,
  product: `${rem(1)} solid #E6E4F0`,
  table: `${rem(1)} solid #31278329`,
  active: `${rem(2)} solid ${color.green}`,
  weak: `${rem(1)} solid #31278314`,
};

const boxShadow = {
  default: `0 ${rem(2)} ${rem(16)} ${color.gray08}`,
  tab: `0 ${rem(2)} ${rem(16)}  ${color.gray08};`,
  input: `0 ${rem(2)} ${rem(4)} #00000014;`,
  secondary: `0px ${rem(2)} ${rem(8)} #00000029;`,
  main: `2px 2px 4px -4px ${colors.placeholder} inset`,
};

const slider = {
  default: `${rem(4)}`,
};

const header = {
  border: `${rem(1)} solid ${rgba(colorsNew.silver, 0.25)}`,
  colors: {
    icon: colorsNew.doveGray,
    iconLoggedIn: colorsNew.mountainMeadow,
    shippingIcon: colorsNew.whiteOpacity35,
  },
};

const footer = {
  border: header.border,
  colors: {
    icon: colorsNew.dustyGray,
    iconBg: colorsNew.whiteOpacity5,
  },
};

const formWithIcon = {
  color: {
    icon: colorsNew.silver,
    placeholder: colorsNew.dustyGray,
  },
};

const grid = {
  padding: 48,
  container: {
    base: 960,
    wide: 1456,
  },
  col: {
    col1: (1 / 12) * 100 + '%',
    col2: (2 / 12) * 100 + '%',
    col3: (3 / 12) * 100 + '%',
    col4: (4 / 12) * 100 + '%',
    col5: (5 / 12) * 100 + '%',
    col6: (6 / 12) * 100 + '%',
    col7: (7 / 12) * 100 + '%',
    col8: (8 / 12) * 100 + '%',
    col9: (9 / 12) * 100 + '%',
    col10: (10 / 12) * 100 + '%',
    col11: (11 / 12) * 100 + '%',
    col12: (12 / 12) * 100 + '%',
  },
};

const loader = {
  color: {
    primary: color.brand,
  },
};

const filter = {
  color: {
    icon: colorsNew.boulder,
  },
};

const breakpoints = {
  l1620: 1620,
  l1400: 1400,
  l1300: 1300,
  l1150: 1150,
  l1050: 1050,
  l925: 925,
  m810: 810,
  m760: 760,
  m600: 600,
  m580: 580,
  s450: 450,
};

const mediab = {
  l1620: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l1620}px) {
      ${css(arg, ...args)}
    }
  `,
  l1400: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l1400}px) {
      ${css(arg, ...args)}
    }
  `,
  l1300: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l1300}px) {
      ${css(arg, ...args)}
    }
  `,
  l1150: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l1150}px) {
      ${css(arg, ...args)}
    }
  `,
  l1050: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l1050}px) {
      ${css(arg, ...args)}
    }
  `,
  l925: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.l925}px) {
      ${css(arg, ...args)}
    }
  `,
  m810: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.m810}px) {
      ${css(arg, ...args)}
    }
  `,
  m760: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.m760}px) {
      ${css(arg, ...args)}
    }
  `,
  m600: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.m600}px) {
      ${css(arg, ...args)}
    }
  `,
  m580: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.m580}px) {
      ${css(arg, ...args)}
    }
  `,
  s450: (arg: any, ...args: any[]) => css`
    @media (max-width: ${breakpoints.s450}px) {
      ${css(arg, ...args)}
    }
  `,
};

const infoBar = {
  activeCircleColor: '#514E49',
  inActiveCircleColor: '#F2EEE8',
};

const pagination = {
  backgroundActive: colors.fuscousGray,
};

const tags = {
  freeDelivery: '#9CC381',
  discount: '#FFC957',
  new: '#9CC381',
  sale: '#FF4464',
  saleOut: '#FFC957',
};

const button = {
  background: colors.primary,
  borderRadius: 4,
};

const mobileNavItem = {
  fontSize: '21px',
  lineHeight: '1.4',
  padding: '15px 0',
  border: '1px dashed colors.borderColor',
  arrow: {
    width: '8px',
    height: '5px',
  },
};

const box = {
  mainBorder: `${rem(1)} solid ${colors.separatorColor}`,
  headerBorder: `${rem(1)} solid ${colors.separatorColor}`,
  iconBorder: `${rem(1)} solid ${colors.separatorColor}`,
  padding: rem(20),
  boxTitle: colors.primaryFontColor,
  iconContentWidth: rem(60),
};

const myAccount = {
  leftSidebar: {
    background: rgba(colors.secondary, 0.15),
    padding: rem(20),
    width: rem(250),
    headerSpacing: `0 0 ${rem(20)} 0`,
  },
  tab: {
    title: colors.primaryFontColor,
    textLeft: colors.primaryFontColor,
    textRight: colors.primaryFontColor,
  },
  orderItem: {
    imageHeight: rem(45),
    imageWidth: rem(45),
    titleColor: colors.primaryFontColor,
    padding: `${rem(10)} 0`,
  },
};

const footerDropdownTitle = {
  titleSizeMobile: '21px',
  titleColor: colors.textPrimary,
  lineHeight: '1.5',
  arrow: {
    width: '8px',
    height: '8px',
  },
};

const product = {
  onStockColor: 'rgba(156, 195, 129, 1)',
  notInStockColor: 'rgba(225, 201,87, 1)',
  activeThumbnailBorder: `${rem(1)} solid ${colors.primary}`,
};

const fonts = {
  primaryFont: `'Roboto', sans-serif;`,
  secondaryFont: `'Bebas Neue', cursive;`,
};

const formElements = {
  border: {
    width: 1,
    color: colors.borderColor,
    radius: 4,
    colorOnFocus: colors.secondary,
  },
  font: fonts.primaryFont,
  gridItem: {
    margin: '0 -7.5px 60px -7.5px',
    padding: '0 7.5px',
    paddingMediaS: '0',
  },
  table: {
    rowHoverColor: rgba(colors.secondary, 0.15),
    border: `${rem(2)} solid ${rgba(colors.secondary, 0.5)}`,
    headerBorder: `${rem(2)} solid ${rgba(colors.secondary, 0.5)}`,
  },
};

const cart = {
  cartStep: {
    default: {
      textColor: '#dddddd',
      numberColor: '#dddddd',
      paddingBottom: '0',
      circleFontFamily: fonts.primaryFont,
      circleFontSize: rem(18),
      circleFontWeight: '600',
    },
    selected: {
      textColor: colors.textPrimary,
      numberColor: colors.secondary,
    },
    done: {
      textColor: colors.textPrimary,
      numberColor: '#81c277',
    },
  },
  button: {
    width: 275,
    height: 60,
    background: button.background,
    borderRadius: button.borderRadius,
  },
  totalPrice: {
    color: colors.primary,
    priceMarginLeft: 10,
    fontSize: 32,
    fontWeight: 600,
    top: rem(3),
    wrapperValign: 'flex-end',
  },
  cartMenuItem: {
    primary: '#ffc957',
    background: '#fef8ed',
  },
  cartItem: {
    imageContainer: {
      width: 40,
      height: 40,
      border: {
        width: 1,
        color: colors.borderColor,
        radius: 0,
      },
    },
    stockAvailabilityColor: colors.textPrimary,
  },
  itemCounter: {
    height: 50,
    border: {
      width: 1,
      style: 'solid',
      color: colors.borderColor,
    },
    counter: {
      width: 60,
    },
    buttons: {
      width: 40,
      leftBorderRadius: 4,
      rightborderRadius: 4,
    },
  },
  discountCard: {
    toggleButtonColor: colors.textPrimary,
    useButtonColor: colors.primary,
  },
  cartSummary: {
    borderTop: `${rem(1)} dashed ${colors.borderColor}`,
    borderBottom: `${rem(1)} dashed ${colors.borderColor}`,
  },
};

const categoryFilter = {
  // filter item styles
  bgColor: color.white,
  color: color.primary,
  border: borders.primary,
  borderRadius: rem(0),
  padding: rem(18),
  margin: `0 0 ${rem(16)}`,

  // active filter styles
  activeBgColor: color.green,
  activeColor: color.white,

  // slider styles
  sliderTrackColor: color.primary,
  sliderRailColor: '#EEEEEE',
  trackBorder: `${rem(4)} solid black`,
  trackBorderColor: `${color.primary}`,
  trackBgColor: color.white,

  // reset filter styles
  textColor: color.textPrimary,
  resetFontSize: rem(14),
  resetFont: font.primary,

  // mobile styles
  mobilePadding: `${rem(24)} ${rem(16)}`,
  mobileMargin: 0,
};

export const theme = {
  categoryFilter,
  categoryColors,
  blogColors,
  blogFonts,
  blogShadows,
  tagColors,
  color: {
    ...color,
  },
  boxShadow: {
    ...boxShadow,
  },
  font: {
    ...font,
  },
  grid: {
    ...grid,
  },
  loader: {
    ...loader,
  },
  header: {
    ...header,
  },
  footer: {
    ...footer,
  },
  formWithIcon: {
    ...formWithIcon,
  },
  filter: {
    ...filter,
  },
  colors: {
    ...colors,
  },
  infoTexts,
  primary: '#FFFFFF',
  secondary: '#F2FAFA',
  successColor: '#9CC381',
  warningColor: colors.secondary,
  dangerColor: '#D24D57',
  btnPrimary: colors.primary,
  btnSecondary: colors.base,
  btnSecondaryTextColor: colors.black,
  separatorColor: colors.borderColor,
  borderRadius: rem(4),
  borderSolid: `${rem(1)} solid ${color.borderColor}`,
  borderDashed: `${rem(1)} dashed ${colors.borderColor}`,
  box,
  black: '#000000',
  fontSizeXXS: rem(12),
  fontSizeXS: rem(14),
  fontSizeS: rem(16),
  fontSizeM: rem(18),
  fontSizeL: rem(24),
  fontSizeXL: rem(32),
  fonts: {
    primaryFont: `'Roboto', sans-serif;`,
    secondaryFont: `'Bebas Neue', cursive;`,
  },
  index: {
    default: 0,
    categoryOverlay: 100,
    priorityContent: 200,
    priorityContentShadow: 199,
    overlay: 300,
    menu: 400,
    tooltip: 450,
    modalShadow: 500,
    chatWidget: 550,
    toTop: 560,
    // Above the sticky header (1000) and TopPromoBar (1001), which otherwise cover modals.
    modal: 1100,
    max: 999999,
  },
  myAccount,
  button,
  pagination,
  mobileNavItem,
  footerDropdownTitle,
  cart,
  infoBar,
  cartStep,
  cartChooser,
  borders,
  tags,
  product,
  mainContainerSize: '1167px',
  formElements,
  media,
  mediab,
  transition,
  transitions,
  heatCategory,
  woodCategory,
  restCategory,
  slider,
};
